// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import RedebitPaymentStatusListResultModel from '../../model/redebit-payment-status-list-result-model';
import RedebitPaymentStatusListResultDTO from '../dto/redebit-payment-status-list-result-dto';
import dtoSchema from '../schemas/redebit-payment-status-list-result-schema';
import RedebitPaymentStatusModel from '../../model/redebit-payment-status-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class RedebitPaymentStatusListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<RedebitPaymentStatusListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => RedebitPaymentStatusModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: RedebitPaymentStatusModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<RedebitPaymentStatusListResultDTO>): RedebitPaymentStatusListResultModel;
  static toModel(dto: DeepPartial<RedebitPaymentStatusListResultDTO> | undefined | null): RedebitPaymentStatusListResultModel | undefined;
  static toModel(dto: DeepPartial<RedebitPaymentStatusListResultDTO> | undefined | null): RedebitPaymentStatusListResultModel | undefined {
    return dto ? new RedebitPaymentStatusListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<RedebitPaymentStatusListResultModel> | RedebitPaymentStatusListResultModel): RedebitPaymentStatusListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as RedebitPaymentStatusListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for RedebitPaymentStatusListResultModel, can not map to RedebitPaymentStatusListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
